module.exports = __webpack_public_path__ + "img/8.cadc9a87.png";